import "./index.css"
import { QueryClientProvider } from "@tanstack/react-query"
import { RouterProvider, createRouter } from "@tanstack/react-router"
import { ModalRenderer, Toaster } from "@ui"
import { analytics } from "@utils/analytics"
import React from "react"
import ReactDOM from "react-dom/client"

import { queryClient } from "./queryClient"
import { routeTree } from "./routeTree.gen"

analytics.init()

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  context: { queryClient },
})

// oxlint-disable-next-line no-non-null-assertion
ReactDOM.createRoot(document.querySelector("#root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
      <ModalRenderer />
      <Toaster />
    </QueryClientProvider>
  </React.StrictMode>,
)
